import { IResolvers, TypeSource } from '@graphql-tools/utils';
import { makeExecutableSchema, scalarTypeDefs } from '@spazious/dollhouse-graphql';
import {
  ApolloClient,
  DefaultContext,
  InMemoryCache,
  onError,
  SchemaLink,
  setContext,
} from '@spazious/dollhouse-graphql/apollo';

export const createContextLink = <Context extends DefaultContext>(context: Context) => {
  return setContext(() => {
    return context;
  });
};

/**
 * Creates an Apollo client with the provided API client.
 */
export const createApolloClient = <TContext extends DefaultContext>(
  context: TContext,
  typeDefs: TypeSource,
  resolvers: IResolvers<any, TContext> | Array<IResolvers<any, TContext>>
) => {
  const ctxLink = createContextLink(context);
  const schema = makeExecutableSchema({
    typeDefs: [scalarTypeDefs, typeDefs],
    resolvers,
  });

  const apolloCache = new InMemoryCache((window as any).__APOLLO_STATE__);

  const graphqlClient = new ApolloClient({
    cache: apolloCache,
    link: onError(({ graphQLErrors, networkError }) => {
      graphQLErrors?.forEach(({ originalError }) => {
        originalError && console.error('GraphQL error:', originalError);
      });
      networkError && console.error('Network error:', networkError);
    }).concat(
      ctxLink.concat(
        new SchemaLink({
          schema,
          context: context,
        })
      )
    ),
  });

  return graphqlClient;
};
